import axios from "axios";
import type { NamedColor } from "components/filter/color-filter/ColorFilter";
import i18next from "i18next";
import type { ColorCieLab, ColorCieLch } from "./color-math";

export interface RalDesignPlusColor {
  ral: string;
  lab: ColorCieLch;
  name: string;
  code: string;
}

export interface ResRalDesignPlusColor {
  lab: ColorCieLab;
  name: string;
  code: string;
}

export function loadRalDesignPlusColors(): Promise<Array<RalDesignPlusColor>> {
  const currentLanguage = i18next.language;
  let jsonFileName = "ral-design-plus.json";

  if (currentLanguage === "de") {
    jsonFileName = "ral-design-plus-de.json";
  } else if (currentLanguage === "zh") {
    jsonFileName = "ral-design-plus-zh.json";
  }

  return axios
    .get(`/colors/${jsonFileName}`)
    .then((res) => res.data)
    .then((colors: ResRalDesignPlusColor[]) =>
      colors.map((color: ResRalDesignPlusColor) =>
        convertNamedColorToRalDesignPlusColor({
          name: color.name,
          value: color.lab,
          code: color.code,
        }),
      ),
    );
}

export function convertNamedColorToRalDesignPlusColor(
  namedColor: NamedColor,
): RalDesignPlusColor {
  const regexRal = /(RAL \d{3} \d{2} \d{2})\s(.+)/;
  const ral: string = namedColor.name.match(regexRal)?.[1] ?? "";

  return {
    ral,
    lab: namedColor.value,
    name: namedColor.name,
    code: namedColor.code || "",
  };
}
